import PropTypes from "prop-types"
import classnames from "classnames"
import LoaderDots from "shared/components/loader_dots"

export default function Footer({ includeSubmit, enabled, isSaving, label = "Save", onSaveClicked }) {
  const handleSubmit = event => {
    event.preventDefault()
    onSaveClicked()
  }

  return (
    <div className="config-footer">
      {(includeSubmit || isSaving) && (
        <div className="button">
          <button
            type="button"
            className={classnames("button-primary", { saving: isSaving })}
            onClick={handleSubmit}
            disabled={!enabled || isSaving}
          >
            {isSaving ? (
              <>
                Saving
                <LoaderDots className="loader-dots" />
              </>
            ) : (
              label
            )}
          </button>
        </div>
      )}
    </div>
  )
}

Footer.propTypes = {
  enabled: PropTypes.bool,
  includeSubmit: PropTypes.bool,
  label: PropTypes.string,
  onSaveClicked: PropTypes.func,
  isSaving: PropTypes.bool.isRequired,
}
